import { ResourceLanguage } from 'i18next';

const en: ResourceLanguage = {
    translation: {
        Copyright: 'All rights reserved - Adam Michaud',
        MoreDetails: 'more details',
        TechnicalSkills: 'Technical skills',
        SkillTiers: {
            Expert: 'Expert',
            Proficient: 'Proficient',
            Familiar: 'Familiar',
        },

        Intro: {
            Hello: 'Hello, I am',
            JobTitle: 'Software Architect & Full-Stack Developer, M.Eng',
        },

        Contact: {
            ContactMe: 'Contact me',
            Email: 'Email',
            Phone: 'Phone',
        },

        Navigation: {
            Home: 'Home',
            About: 'About me',
            Skills: 'Skills',
            Experiences: 'Experiences',
            Projects: 'Projects',
            Contact: 'Contact me',
            ChangeLang: 'Français',
        },

        AboutMe: {
            Title: 'About me',
            Infos: "I'm Adam — a software architect and full-stack developer based in Montreal. Over the past 5+ years I've delivered cloud-native .NET and Angular platforms end to end: I led the migration of a 160,000-line legacy application to Blazor WebAssembly on Azure, built an MCP server to bring AI-assisted, agentic development into our delivery pipeline, and set the Infrastructure-as-Code and CI/CD standards used firm-wide. I drive architecture, mentor developers, and turn complex, high-stakes systems into clean, maintainable products.",
        },

        Interests: {
            Title: 'My fields of interest',
            Programming: {
                Title: 'Cloud Architecture',
                Infos: 'Designing scalable, cloud-native systems and shared frameworks that help teams ship faster and businesses reach their digital goals.',
            },
            ArtificialIntelligence: {
                Title: 'AI & Agentic Development',
                Infos: 'I build AI-assisted and agentic tooling — like MCP servers — that connect applications to language models and move complex problems forward.',
            },
            VideoGames: {
                Title: 'Engineering Excellence',
                Infos: 'From clean architecture and SOLID design to CI/CD and Infrastructure as Code, I build systems that stay maintainable and reliable at scale.',
            },
        },

        Education: {
            Title: ' Education',
            Master: {
                Degree: 'M.Eng in Computer engineering',
                School: 'Polytechnique Montreal',
            },

            Bachelor: {
                Degree: 'B.Sc. Computer science',
                School: 'University of Montreal',
                Scholarship: 'Excellence Scholarship from DIRO Graduates and Professors',
                Mention: 'Mention of academic excellence',
            },

            College: {
                Degree: 'DEC Computer science and mathematics',
                School: 'Lionel-Groulx College',
                RScore: 'R Score',
            },
        },

        WorkExperiences: {
            Title: ' Work experiences',
            NormandinBeaudry: {
                Title: 'Senior Full-Stack Developer / Software Architect',
                Dates: 'November 2024 - Today',
                Dept: 'Innovation & Architecture',
                Tasks: {
                    Task1: 'Led firm-wide architecture initiatives, building shared Blazor and .NET API frameworks (clean architecture) delivered as NuGet packages so teams could focus on features.',
                    Task2: 'Built an MCP (Model Context Protocol) server connecting our applications to AI language models, and adopted AI-assisted, agentic development to accelerate delivery.',
                    Task3: 'Planned and directed the migration of a 160k-line legacy WinForms application — a financial platform reporting on billions in invested assets — to Blazor WebAssembly on Azure with a .NET API backend.',
                    Task4: 'Standardized infrastructure and delivery with Terraform-based Infrastructure as Code (IaC) and reusable CI/CD templates in Azure DevOps.',
                    Task5: 'Implemented Entra ID authentication, migrating the in-house auth platform off IdentityServer 4.',
                },
            },
            CDPQ: {
                Title: 'Developer intern',
                Dates: 'January 2021 - April 2021',
                Dept: 'Digital experience',
                Tasks: {
                    Task1: 'Designed and developed efficient self-service digital platforms.',
                    Task2: 'Built responsive user interfaces to improve the user experience.',
                    Task3: 'Developed and configured analytics collection systems and data visualization dashboards based on Google Analytics technologies, collaborating within a multidisciplinary agile team.',
                },
            },
            JovacoProgrammer: {
                Title: 'Programmer-Analyst',
                Dates: 'May 2021 - January 2024',
                Dept: 'Cloud solutions',
                Tasks: {
                    Task1: 'Designed and architected modern web applications deployed to the cloud.',
                    Task2: 'Maintained a large legacy application serving 200+ client companies, each with up to thousands of users.',
                    Task3: 'Built full-stack web applications, primarily with Angular and C#.',
                    Task4: 'Designed usability-focused interfaces in Figma to improve the user experience.',
                    Task5: 'Automated CI/CD pipelines in Azure DevOps, speeding up delivery and catching regressions before release.',
                },
            },
            JovacoTechLead: {
                Title: 'Cloud Tech Lead / Architect',
                Dates: 'January 2024 - November 2024',
                Dept: 'Cloud solutions',
                Tasks: {
                    Task1: 'Mentored a team of developers through code reviews and pair programming, raising overall code quality.',
                    Task2: 'Introduced improved work methods such as structured requirement breakdown.',
                    Task3: 'Defined and validated technical requirements for new features.',
                    Task4: 'Drove product development end to end — writing code, building automated tests, and establishing coding standards.',
                    Task5: 'Tracked emerging cloud technologies and shared actionable insights with the team.',
                },
            },
        },

        Projects: {
            Title: 'Recent project',
            Featured: {
                Tag: 'Tech for Good',
                Name: 'Unitas Humanitas',
                Subname: 'Non-profit platform · Pro bono',
                Infos: 'I designed and built — pro bono — the full bilingual (FR/EN) platform for Unitas Humanitas, a Quebec non-profit restoring dignity and building hope for vulnerable children and families. A React front end backed by a PayloadCMS (Next.js) headless CMS, deployed on Azure (Static Web Apps, Container Apps, Azure DNS, Communication Services) with Terraform Infrastructure as Code and GitHub Actions CI/CD.',
            },
        },

        WorkTogether: {
            Title: "Let's work together",
            Infos: 'Are you looking for the perfect candidate for your next ambitious project? I am always motivated to take up challenges and participate in the creation of new digital ideas. Feel free to contact me to discuss how I can help you turn your idea into reality.',
        },

        Location: {
            City: 'Montreal',
            Province: 'Quebec',
        },
    },
};

export default en;
